import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { changeDocTitle } from 'src/components/helpers';

const publicRouteGroups = [
  {
    title: 'Inicio y cuenta',
    routes: [
      {
        path: '/',
        name: 'Inicio',
        purpose: 'Página de bienvenida. Acceso al perfil o a la reserva de eventos.',
      },
      {
        path: '/login',
        name: 'Iniciar sesión',
        purpose: 'Inicio de sesión para colaboradores y personal autorizado.',
      },
      {
        path: '/perfil',
        name: 'Perfil',
        purpose: 'Panel del asistente: perfil, Crecer, grupos y experiencia.',
      },
    ],
  },
  {
    title: 'Donaciones',
    routes: [
      {
        path: '/diezmosyofrendas',
        name: 'Diezmos y ofrendas',
        purpose: 'Realizar donaciones a la iglesia.',
      },
      {
        path: '/legado',
        name: 'Legado',
        purpose: 'Landing de la campaña Legado.',
      },
    ],
  },
  {
    title: 'Servicios y eventos',
    routes: [
      {
        path: '/servicio/reservacion',
        name: 'Reservación de servicio',
        purpose: 'Reservar cupo para un servicio o evento en campus.',
      },
      {
        path: '/servicio/reservacion/generaciones',
        name: 'Reservación Generaciones',
        purpose: 'Reservación de padres/cuidadores para Generaciones.',
      },
      {
        path: '/certificado/evento',
        name: 'Certificado de evento',
        purpose: 'Consultar o descargar el certificado de un evento.',
      },
    ],
  },
  {
    title: 'Grupos',
    routes: [
      {
        path: '/grupos/registrarse',
        name: 'Registrarse en un grupo',
        purpose: 'Inscripción a un grupo de Comunidad.',
      },
      {
        path: '/grupos/lider',
        name: 'Vista de líder',
        purpose: 'Gestión y asistencia del grupo para líderes (con acceso).',
      },
      {
        path: '/grupos/acuerdo/:doc',
        name: 'Acuerdo de confidencialidad',
        purpose: 'Firma del acuerdo de confidencialidad del grupo (enlace personalizado).',
      },
      {
        path: '/grupos/encuesta/:hexaCode?',
        name: 'Encuesta de prospectos a líderes',
        purpose: 'Encuesta para aspirantes o prospectos a liderazgo.',
      },
      {
        path: '/grupos/aspirante',
        name: 'Formulario de aspirante a líder',
        purpose: 'Inscripción como aspirante a líder de grupo.',
      },
      {
        path: '/grupos/aspirante/:leaderToken',
        name: 'Encuesta para el líder',
        purpose: 'Formulario que completa el líder sobre un aspirante (enlace con token).',
      },
    ],
  },
  {
    title: 'Crecer',
    routes: [
      {
        path: '/crecer/encuestas',
        name: 'Encuestas de personalidad',
        purpose: 'Encuestas de personalidad de Crecer.',
      },
      {
        path: '/crecer/registrarse/:seminary',
        name: 'Registro a seminario',
        purpose: 'Inscripción a un seminario de Crecer (según el seminario en la URL).',
      },
      {
        path: '/crecer/autoregistro',
        name: 'Autoregistro de asistencia',
        purpose: 'Registro de asistencia a clases o encuentros de Crecer.',
      },
      {
        path: '/crecer/autoasistencia',
        name: 'Autoasistencia',
        purpose: 'Flujo de autoasistencia a Crecer.',
      },
      {
        path: '/crecer/seminario-relaciones-sanas',
        name: 'Seminario Relaciones Sanas',
        purpose: 'Inscripción e información del seminario de relaciones sanas.',
      },
      {
        path: '/crecerplus',
        name: 'Crecer Plus',
        purpose: 'Academia Crecer Plus: cursos y contenido formativo.',
      },
      {
        path: '/crecerplus/:courseId',
        name: 'Curso Crecer Plus',
        purpose: 'Detalle de un curso específico de Crecer Plus.',
      },
    ],
  },
  {
    title: 'Experiencia y Conexión',
    routes: [
      {
        path: '/bienvenido',
        name: 'Nuevos miembros',
        purpose: 'Formulario de bienvenida / Conexión para nuevos miembros.',
      },
      {
        path: '/nuevo-voluntario',
        name: 'Nuevo voluntario',
        purpose: 'Formulario para servir como voluntario en Experiencia.',
      },
      {
        path: '/experiencia/voluntarios',
        name: 'Voluntarios de Experiencia',
        purpose: 'Consulta e ingreso de voluntarios de Experiencia.',
      },
      {
        path: '/voluntarios-servicio',
        name: 'Ingreso de voluntarios',
        purpose: 'Check-in de voluntarios confirmados para el servicio.',
      },
    ],
  },
  {
    title: 'Matrimonio',
    routes: [
      {
        path: '/solicitud-matrimonio',
        name: 'Solicitud de matrimonio',
        purpose: 'Formulario público para solicitar acompañamiento matrimonial.',
      },
      {
        path: '/solicitudes-matrimonio',
        name: 'Solicitudes (facilitadores)',
        purpose: 'Listado de solicitudes para facilitadores autorizados.',
      },
    ],
  },
  {
    title: 'Red y consejería',
    routes: [
      {
        path: '/inscripcion-red-empresas',
        name: 'Inscripción Red Empresas',
        purpose: 'Inscripción a la Red Comunidad Empresas.',
      },
      {
        path: '/catalogo-red-empresas',
        name: 'Catálogo Red Empresas',
        purpose: 'Catálogo de empresas de la red Comunidad.',
      },
      {
        path: '/consejeria',
        name: 'Consejería',
        purpose: 'Formulario “Necesito ayuda” para solicitar consejería.',
      },
    ],
  },
  {
    title: 'Utilidades',
    routes: [
      {
        path: '/utils/generador-qr',
        name: 'Generador de QR',
        purpose: 'Herramienta para generar códigos QR.',
      },
      {
        path: '/utils/qr',
        name: 'Generador de QR (alias)',
        purpose: 'Misma herramienta de generación de QR.',
      },
    ],
  },
];

const MapPage = styled.div`
  max-width: 920px;
  margin: 0 auto;
  padding: 1.5rem 1rem 3rem;
  background: #fff;
  border-radius: 12px;

  .page-title {
    color: #2596c2;
    font-size: 2rem;
    margin: 0 0 0.35rem;
  }

  .page-intro {
    color: #555;
    margin: 0 0 1.75rem;
    line-height: 1.45;
    max-width: 40rem;
  }

  .group {
    margin-bottom: 1.75rem;
  }

  .group-title {
    color: #1a1a1a;
    font-size: 1.15rem;
    margin: 0 0 0.75rem;
    padding-bottom: 0.4rem;
    border-bottom: 2px solid #2596c2;
  }

  .route-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .route-item {
    display: grid;
    gap: 0.2rem 1rem;
    padding: 0.85rem 0;
    border-bottom: 1px solid #eee;

    @media (min-width: 640px) {
      grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.6fr);
      align-items: baseline;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .route-name {
    font-weight: 600;
    color: #222;
    margin: 0;
  }

  .route-path {
    display: inline-block;
    margin-top: 0.2rem;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 0.85rem;
    color: #2596c2;
    text-decoration: none;
    word-break: break-all;

    &:hover {
      text-decoration: underline;
    }
  }

  .route-purpose {
    margin: 0;
    color: #555;
    line-height: 1.4;
    font-size: 0.95rem;
  }

  .note {
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid #e5e5e5;
    font-size: 0.85rem;
    color: #777;
    line-height: 1.4;
  }
`;

const linkablePath = (path) => path.replace(/\/:[^/?]+[?]?/g, '').replace(/\/$/, '') || '/';

const PublicRoutesMap = () => {
  useEffect(() => {
    changeDocTitle('Mapa de rutas públicas');
  }, []);

  return (
    <MapPage>
      <h1 className="page-title">Mapa de rutas públicas</h1>
      <p className="page-intro">
        Rutas abiertas de la aplicación (sin autenticación). Algunas requieren un enlace
        personalizado, un token o identificación previa.
      </p>

      {publicRouteGroups.map((group) => (
        <section className="group" key={group.title}>
          <h2 className="group-title">{group.title}</h2>
          <ul className="route-list">
            {group.routes.map((route) => (
              <li className="route-item" key={route.path}>
                <div>
                  <p className="route-name">{route.name}</p>
                  <Link className="route-path" to={linkablePath(route.path)}>
                    {route.path}
                  </Link>
                </div>
                <p className="route-purpose">{route.purpose}</p>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </MapPage>
  );
};

export default PublicRoutesMap;
